module.exports = __webpack_public_path__ + "media/images/flags/16/British-Virgin-Islands-80fd85546ae69426fce1b6248dff96e2.png";